import request from '@/utils/infrastructure/communication/request';

export async function generateReportToken(id) {
  return request(`/report/generateToken/${id}`, {
    method: 'POST',
  });
}

export async function updateFavorite({ id, state }) {
  return state
    ? request.delete(`/userFavoriteReport/${id}`, {})
    : request.post('/userFavoriteReport', { data: { reportId: id } });
}
